import { TokenData } from '../../models/auth/TokenData';
import { client } from '../apiClient';
import { REACT_APP_CLIENT_ID } from '../../utils/config';

export const sendMagicLink = async (email: string, fingerprint?: string, language?: string): Promise<void> => {
  await client(true, false).post('/auth/magic-link/send', { email, fingerprint, language });
};

export const authenticateWithMagicLink = async (token: string, fingerprint?: string): Promise<TokenData> => {
  const response = await client(true, false).post<TokenData>('/auth/magic-link/authenticate', {
    token,
    client_id: REACT_APP_CLIENT_ID,
    fingerprint,
  });
  return response.data;
};

export const authenticateWithGoogle = async (
  credential: string,
  fingerprint?: string,
  language?: string
): Promise<TokenData> => {
  const response = await client(true, false).post<TokenData>('/auth/google', {
    credential,
    client_id: REACT_APP_CLIENT_ID,
    fingerprint,
    language,
  });
  return response.data;
};

export const autoReactivate = async (token: string): Promise<TokenData> => {
  const response = await client(true, false).get<TokenData>('/auth/auto-reactivation', {
    params: { token, client_id: REACT_APP_CLIENT_ID },
  });
  return response.data;
};

export const TOKEN_KEY = 'token';

export const saveTokenData = (token: TokenData): void => {
  localStorage.setItem(TOKEN_KEY, JSON.stringify(token));
};

export const updateTokenData = (firstName: string, lastName: string): void => {
  const tokenString = localStorage.getItem(TOKEN_KEY);

  if (tokenString) {
    const tokenData = JSON.parse(tokenString) as TokenData;
    const user = tokenData.user;
    user.firstName = firstName;
    user.lastName = lastName;
    tokenData.user = user;
    saveTokenData(tokenData);
  }
};

export const getTokenData = (): TokenData | null => {
  const tokenString = localStorage.getItem(TOKEN_KEY);

  if (tokenString) {
    const tokenData = JSON.parse(tokenString) as TokenData;
    tokenData.accessTokenExpiresAt = new Date(tokenData.accessTokenExpiresAt);
    return tokenData;
  } else {
    return null;
  }
};

export const removeTokenData = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

export const isTokenValid = (tokenData: TokenData): boolean =>
  tokenData.accessTokenExpiresAt.getTime() > Date.now();

export const refreshAccessToken = async (): Promise<TokenData> => {
  try {
    const tokenDataFromStorage = getTokenData();
    if (!tokenDataFromStorage) {
      throw Error('Incorrect refresh token');
    }

    const data = new URLSearchParams();
    data.append('grant_type', 'refresh_token');
    data.append('client_id', REACT_APP_CLIENT_ID);
    data.append('refresh_token', tokenDataFromStorage.refreshToken);

    const response = await client(false, false).post('/auth/refresh', data.toString());
    return response.data as TokenData;
  } catch (error) {
    throw Error('Unable to refresh token');
  }
};
